// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.like-plusabout .like-plus-how-work {
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
}
.like-plusabout .like-plus-where-use {
  min-height: 236px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
}
.like-plusabout .like-plus-where-use .ant-typography-white {
  color: #FFF;
}
.like-plusabout .like-plus-where-use .where-use-icon {
  stroke-width: 1 !important;
}
.white-icon {
  color: #FFF;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/LikePlus/LikePlusAbout.less"],"names":[],"mappings":"AAAA;EAEQ,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;AAAR;AALA;EASQ,iBAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;AADR;AAZA;EAgBY,WAAA;AADZ;AAfA;EAoBY,0BAAA;AAFZ;AAOA;EACI,WAAA;AALJ","sourcesContent":[".like-plusabout {\n    .like-plus-how-work {\n        border-top-width: 0px;\n        border-bottom-width: 0px;\n        border-left-width: 0px;\n        border-right-width: 0px;\n    }\n\n    .like-plus-where-use {\n        min-height: 236px;\n        border-top-width: 0px;\n        border-bottom-width: 0px;\n        border-left-width: 0px;\n        border-right-width: 0px;\n\n        .ant-typography-white {\n            color: #FFF;\n        }\n\n        .where-use-icon {\n            stroke-width: 1 !important;\n        }\n    }\n}\n\n.white-icon {\n    color: #FFF;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
